var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SessionTitle',{staticClass:"mb-6",attrs:{"text":_vm.$t('common.aboutUs'),"color":"#000000"}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.getText(_vm.data).content)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }